export default "__VITE_ASSET__mwrtxNpwZtt79LUBErT4UQ__"